import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'antd';
import axios from '../../axios';
import '../stylesheets/EditJournalPage.css';

export function EditJournalPage() {
    const [journal, setJournal] = useState([]);
    const { token } = useContext(AuthContext);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        loadingData();
    }, [])

    /** 
    ===========================================
    * @functions
    ===========================================
    **/

    async function loadingData() {
        const response = await axios.get(`journals/${id}`);
        setJournal(response.data);
    }

    const handleInputChange = (e) => {
        setJournal({ ...journal, [e.target.name]: e.target.value });
    };

    const handleInputCheckboxChange = () => {
        const changingJournal = journal.disabled = !journal.disabled;
        setJournal({ ...journal, disabled: changingJournal });
    };

    const handleAddContent = () => {
        const newContentItem = {
            _id: journal.content.length + 1,
            text: '',
            page: '',
        };

        setJournal({ ...journal, content: [...journal.content, newContentItem] });
    };

    const handleContentTextChange = (event, id) => {
        const { value } = event.target;

        setJournal((prevJournal) => ({
            ...prevJournal,
            content: prevJournal.content.map((item) =>
                item._id === id ? { ...item, text: value } : item
            ),
        }));
    };

    const handleContentPageChange = (event, id) => {
        const { value } = event.target;

        setJournal((prevJournal) => ({
            ...prevJournal,
            content: prevJournal.content.map((item) =>
                item._id === id ? { ...item, page: value } : item
            ),
        }));
    };

    const handleContentDelete = (id) => {
        const confirm = window.confirm('Ջնջե՞լ այս տողը:');

        if (confirm) {
            setJournal((prevJournal) => ({
                ...prevJournal,
                content: prevJournal.content.filter((item) => item._id !== id),
            }));
        }
    };

    const submitHandler = async (event) => {
        event.preventDefault();

        if (!journal.disabled) {
            let emptyArray = journal.content = [];
            setJournal({ ...journal, content: emptyArray });
        }

        // if any of the contents is empty, it is cleared
        const updateContent = journal.content.filter(item => item.text !== '');
        const updatedJournal = { ...journal, content: updateContent };
        setJournal(updatedJournal);

        // deleting the ID-s I added to let MongoDB add its own
        updatedJournal.content.forEach(item => delete item._id);
        
        try {
            await axios.put(`journals/edit/${id}`, updatedJournal, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            navigate('/admin');
        } catch (error) {
            alert('Տեղի ունեցավ սխալ հարցումն ուղարկելիս:');
            console.log('Error sending request.', error);
        }
    };

    return (
        <div className='EditJournalPage'>
            <h1 className='heading'>
                Թարմացնել <b>{journal.title}-{journal.year}</b> ամսաթերթը
            </h1>

            <form onSubmit={submitHandler}>
                <div className='box'>
                    <div className='form-item'>
                        <p>Տարեթիվ</p>

                        <input
                            type='number'
                            name='year'
                            value={journal.year || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className='form-item'>
                        <p>Վերնագիր</p>

                        <input
                            type='text'
                            name='title'
                            value={journal.title || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className='box'>
                    <div className='form-item'>
                        <p>Հասցե</p>

                        <input
                            type='text'
                            name='url'
                            value={journal.url || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className='form-item'>
                        <p>Նկարի հասցեն</p>

                        <input
                            type='text'
                            name='img'
                            value={journal.img || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className='form-item valid'>
                    <label>
                        <span>Valid</span>

                        <input
                            type='checkbox'
                            name='disabled'
                            checked={journal.disabled || ''}
                            onChange={handleInputCheckboxChange}
                        />
                    </label>
                </div>

                {/* =============== content =============== */}
                {
                    journal.disabled && <div className='content'>
                        <Button className='addContent' type='default' onClick={handleAddContent}>
                            Ավելացնել բովանդակություն
                        </Button>


                        {
                            journal.content.map((item, index) => (
                                <div key={index} className='box'>
                                    <input
                                        type='text'
                                        value={item.text}
                                        className='text-input'
                                        placeholder='Բովանդակություն'
                                        onChange={(e) => handleContentTextChange(e, item._id)}
                                    />

                                    <input
                                        type='number'
                                        value={item.page}
                                        placeholder='Էջ'
                                        className='page-input'
                                        onChange={(e) => handleContentPageChange(e, item._id)}
                                    />

                                    <Button 
                                      danger
                                      type='primary' 
                                      onClick={() => handleContentDelete(item._id)}
                                    >
                                        <i className='fa solid fa-trash' />
                                    </Button>
                                </div>
                            ))
                        }
                    </div>
                }

                <Button type='primary' htmlType='submit' className='addJournalBtn'>
                    Թարմացնել ամսագիրը
                </Button>
            </form>
        </div>
    )
}
